/* eslint-disable no-console */
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import {
  PriceDataRequest,
  PriceDataResponse,
  SourceIdToRank,
} from '../models/price-data'
import { PricingSource } from '../models/price-source'
import { PriorityList } from '../models/priority-list'
import { SleeveSimpleAccounts } from '../models/sleeve-simple-accounts.model'

const PRICING_HOST = 'helios-pricing'

const AGGREGATE_SUBACCOUNTS_URL = `helios-external-raw-data/account/subAccountMap/`

@Injectable({
  providedIn: 'root',
})
export class PricingService {
  constructor(private readonly httpClient: HttpClient) {}

  getPriorityList(
    accountId: number,
    endDate: string,
  ): Observable<PriorityList[][]> {
    return this.httpClient.get<PriorityList[][]>(
      `${PRICING_HOST}/priorityList/accounts`,
      {
        params: new HttpParams()
          .set('date', endDate)
          .set('accountId', accountId.toString()),
      },
    )
  }

  fetchSubAccounts(accountId: number): Observable<SleeveSimpleAccounts[]> {
    return this.httpClient.get<SleeveSimpleAccounts[]>(
      `${AGGREGATE_SUBACCOUNTS_URL}` + accountId,
    )
  }

  getAllAvailableSources(accountId: number): Observable<PricingSource[]> {
    return this.httpClient.get<PricingSource[]>(`${PRICING_HOST}/allSources`, {
      params: new HttpParams().set('accountId', accountId),
    })
  }

  getCompletePricingData(
    accountId: number,
    securityIds: number[],
    sourceIds: number[],
    beginDate: string,
    endDate: string,
    sourceIdToRank?: SourceIdToRank,
  ): Observable<PriceDataResponse[]> {
    const priceDataRequest: PriceDataRequest = {
      accountId: accountId,
      securityIds: securityIds,
      sourceIds: sourceIds,
      beginDate: beginDate,
      endDate: endDate,
      sourceIdToRank: sourceIdToRank,
    }
    return this.httpClient.post<PriceDataResponse[]>(
      `${PRICING_HOST}/completePricingData`,
      priceDataRequest,
    )
  }
}
